/* eslint-disable no-unused-expressions */

import { useKeycloak } from "@react-keycloak/web";
import { useCallback, useEffect } from "react";

import { setSessaoToken } from "../helpers/Token";
import { axiosPisCofins } from "../constants/axiosConfig";
import { isContratoAceito } from "./Auth/actions";

const buscarDadosCliente = () => {
  if (window.location.pathname === "/") {
    axiosPisCofins
      .post("usuario/obterDadosUsuario", {})
      .then(async (response) => {
        const {
          Login,
          CodigoCliente,
          IdLogin,
          IsAdmin,
          PlanoMaster,
          PlanoRecuperadorLimitado,
          LogoEmpresa,
          PlanoTeste,
          CodigoAcessoPlanilha,
          OcultarPlanilhaCalculo,
          NomeDoUsuario,
          ClienteRazaoSocial,
          PlanoProfissionalLiberalSimples,
          PlanoProfissionalLiberal,
          PlanoMeuPrimeiroClienteCompleto,
        } = response.data.Retorno;

        if (response.data?.StatusCode === 200) {
          sessionStorage.setItem("Login", window.btoa(Login));
          sessionStorage.setItem("IdLogin", window.btoa(IdLogin || 0));
          sessionStorage.setItem("nome", NomeDoUsuario);
          sessionStorage.setItem("email", Login);
          setSessaoToken({
            planoMaster: PlanoMaster,
            planoTeste: PlanoTeste,
            planoRecuperadorLimitado: PlanoRecuperadorLimitado,
            codigoAcessoPlanilha: CodigoAcessoPlanilha,
            ocultarPlanilhaCalculo: OcultarPlanilhaCalculo,
            clienteRazaoSocial: ClienteRazaoSocial,
            planoProfissionalLiberalSimples: PlanoProfissionalLiberalSimples,
            planoProfissionalLiberal: PlanoProfissionalLiberal,
            planoMeuPrimeiroClienteCompleto: PlanoMeuPrimeiroClienteCompleto,
          });

          window?.clarity?.('identify', Login);
          window?.clarity?.('set','Login usuário', Login);
          window?.clarity?.('set', 'Código cliente', CodigoCliente);
          
          if (IsAdmin) sessionStorage.setItem("IsAdmin", IsAdmin);
          if (LogoEmpresa) sessionStorage.setItem("LogoEmpresa", LogoEmpresa);

          if (await isContratoAceito()) {
            window.location = "/bemvindo";
          } else {
            window.location = "/contrato";
          }
        } else {
          let contaUrl = process.env.REACT_APP_CONTA_URL;

          if (response.data?.StatusCode === 401 && response.data.Mensagem) {
            contaUrl =
              contaUrl + `/Home/Conta?mensagem=${response.data.Mensagem}`;
          }

          window.location = contaUrl;
        }
      })
      .catch((error) => {
        if (error && error && error.response && error.response.status === 483) {
          // Caso n�o esteja logado, redireciona para o Conta ou para o Login
          window.location = `${process.env.REACT_APP_CONTA_URL}/Home/Conta?idstatus=4`;
        } else {
          // Em caso de erro, redireciona para o Conta ou para o Login
          window.location = process.env.REACT_APP_CONTA_URL;
        }
      });
  }
  if (window.location.pathname === "/recuperacao") {
    axiosPisCofins
      .post("usuario/obterDadosUsuario", {})
      .then(async (response) => {
        const {
          Login,
          CodigoCliente,
          IdLogin,
          IsAdmin,
          PlanoMaster,
          PlanoRecuperadorLimitado,
          LogoEmpresa,
          PlanoTeste,
          CodigoAcessoPlanilha,
          OcultarPlanilhaCalculo,
          NomeDoUsuario,
          ClienteRazaoSocial,
          PlanoProfissionalLiberalSimples,
          PlanoProfissionalLiberal,
          PlanoMeuPrimeiroClienteCompleto,
        } = response.data.Retorno;

        if (response.data?.StatusCode === 200) {
          sessionStorage.setItem("Login", window.btoa(Login));
          sessionStorage.setItem("IdLogin", window.btoa(IdLogin || 0));
          sessionStorage.setItem("nome", NomeDoUsuario);
          sessionStorage.setItem("email", Login);
          setSessaoToken({
            planoMaster: PlanoMaster,
            planoTeste: PlanoTeste,
            planoRecuperadorLimitado: PlanoRecuperadorLimitado,
            codigoAcessoPlanilha: CodigoAcessoPlanilha,
            ocultarPlanilhaCalculo: OcultarPlanilhaCalculo,
            clienteRazaoSocial: ClienteRazaoSocial,
            planoProfissionalLiberalSimples: PlanoProfissionalLiberalSimples,
            planoProfissionalLiberal: PlanoProfissionalLiberal,
            planoMeuPrimeiroClienteCompleto: PlanoMeuPrimeiroClienteCompleto,
          });

          window?.clarity?.('identify', Login);
          window?.clarity?.('set','Login usuário', Login);
          window?.clarity?.('set', 'Código cliente', CodigoCliente);
          
          if (IsAdmin) sessionStorage.setItem("IsAdmin", IsAdmin);
          if (LogoEmpresa) sessionStorage.setItem("LogoEmpresa", LogoEmpresa);

        } else {
          let contaUrl = process.env.REACT_APP_CONTA_URL;

          if (response.data?.StatusCode === 401 && response.data.Mensagem) {
            contaUrl =
              contaUrl + `/Home/Conta?mensagem=${response.data.Mensagem}`;
          }
          window.location = contaUrl;
        }
      })
      .catch((error) => {
        if (error && error && error.response && error.response.status === 483) {
          // Caso n�o esteja logado, redireciona para o Conta ou para o Login
          window.location = `${process.env.REACT_APP_CONTA_URL}/Home/Conta?idstatus=4`;
        } else {
          // Em caso de erro, redireciona para o Conta ou para o Login
          window.location = process.env.REACT_APP_CONTA_URL;
        }
      });
  }
};

export default function LoginWrapper({ children }) {
  const {
    keycloak: { authenticated },
  } = useKeycloak();

  const initialRender = useCallback(async () => {
    if (authenticated) buscarDadosCliente();
  }, [authenticated]);

  useEffect(() => {
    initialRender();
  }, [initialRender]);

  return children;
}
